export const OrderPlacedIcon = {
    d: 'M1210,475v7.464l-2.5-2.5-2.5,2.5V475h-7v13a1,1,0,0,0,1,1h17a1,1,0,0,0,1-1V475h-7Zm-5-4h-8a1,1,0,0,0-1,1v2h9v-3Zm13,0h-8v3h9v-2A1,1,0,0,0,1218,471Z',
    transform: 'translate(-1196 -471)'
};